<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" @click="handleExport">导入数据</el-button> -->
        <el-upload
          ref="upload"
          action="/"
          :show-file-list="false"
          :on-change="importExcel"
          :auto-upload="false"
        >
          <el-button slot="trigger" icon="el-icon-upload" type="primary">
            批量导入物流单号
          </el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="门店: " style="margin-left:20px" required>
        <el-select
          style="width:300px"
          multiple
          collapse-tags
          v-model="selectStoreList"
          placeholder="请选择"
          @change="storeChange"
          clearable
        >
          <el-option
            v-for="item in storeList"
            :label="item.storeName"
            :value="item.id + ''"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单号: " style="margin-left:20px">
        <el-input
          v-model="orderNumber"
          placeholder="请输入订单号"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-left:20px">
        <el-input
          v-model="phone"
          placeholder="请输入手机号"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="用户ID: " style="margin-left:20px">
        <el-input
          v-model="userId"
          placeholder="请输入用户id"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:75%">
      <el-table
        border
        :data="dataList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="订单号" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="80" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p style="text-align:center">
                <span style="color: rgb(59, 59, 59);font-weight:600;"
                  >用户id:</span
                >
                <span style="color:red;font-weight:600">{{
                  scope.row.userId
                }}</span>
              </p>
              <div slot="reference" class="name-wrapper addressDetail">
                <el-tag size="medium">{{ scope.row.name }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发货方式" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.delivery === "undefined"
                ? "/"
                : scope.row.delivery === null
                ? "一件代发"
                : scope.row.delivery
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="收货地址"
          width="280"
          align="center"
          prop="address"
        ></el-table-column>
        <el-table-column
          label="订单所属门店"
          width="280"
          align="center"
          prop="storeName"
        ></el-table-column>
        <el-table-column label="留言" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.odescribe == "" ? "-" : scope.row.odescribe
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单总价" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.cost }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" align="center" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.logisticsNumber == ''" style="color:red"
              >暂未填写</span
            >
            <span v-if="scope.row.logisticsNumber != ''">{{
              scope.row.logisticsNumber
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" width="180">
          <template slot-scope="scope">
            <span style="color:red">{{
              scope.row.status == 0
                ? "未发货"
                : scope.row.status == 1
                ? "已发货"
                : scope.row.status == 2
                ? "已完成"
                : scope.row.status == 3
                ? "退款中"
                : scope.row.status == 4
                ? "已退款"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="detailsBtn(scope.row)"
              >详情</el-button
            >
            <!-- <el-button
              style="margin:10px 0"
              size="mini"
              type="danger"
              @click="fahuoBtn(scope.row)"
              >发货</el-button
            > -->
            <el-button size="mini" type="danger" @click="fahuoBtn(scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteBtn(scope.row)"
              :disabled="isRole"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 发货 -->
    <el-dialog
      title="发货"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="提现状态: ">
          <el-select v-model="form.status" placeholder="请选择" clearable>
            <div v-for="item in statusList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input
            v-model="form.logisticsNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="form">
        <el-form-item label="发货地址">
          <el-input v-model="form.address" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataLogisticsNumberBtn"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 订单详情 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
    >
      <el-table
        :data="orderDetailArr"
        style="width: 100%"
        height="400px"
        v-loading="loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="订单号" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="商品id"
          align="center"
          prop="id"
        ></el-table-column>
        <el-table-column
          label="商品名"
          width="280"
          align="center"
          prop="productName"
        ></el-table-column>
        <el-table-column
          label="数量"
          align="center"
          prop="num"
        ></el-table-column>
        <el-table-column
          label="单价"
          align="center"
          prop="price"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectallorder,
  deleteOrder,
  updateSendState,
  updateOrder,
  selectOrderDetail,
  selectorderbyname,
} from "@/services/order";
import { selectStore } from "@/services/store";
import XLSX from "xlsx";
export default {
  data() {
    return {
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      logisticsNumber: "",
      form: {},
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      isRole: false,
      storeList: [],
      selectStoreList: [],
      statusList: [
        { id: 0, name: "未发货" },
        { id: 1, name: "已发货" },
        { id: 2, name: "已完成" },
        { id: 3, name: "退款中" },
        { id: 4, name: "已退款" },
      ],
    };
  },
  created() {
    // 查询用户登陆数据
    this.form.storeId = this.$store.state.supUser.storeId;
    selectStore({ storeName: "" }).then((res) => {
      if (this.$store.state.supUser.role_id === "0") {
        /* 店长 */
        this.storeList = res.data;
        this.select();
        return;
      }

      /* 员工 */
      this.selectStoreList = this.form.storeId?.split(",");
      this.storeList = this.selectStoreList?.map((item) => {
        let result = res.data?.find((value) => {
          console.log(value);
          return value.id == item;
        });
        return result;
      });
      this.select();
    });
  },
  methods: {
    select() {
      // 查询订单数据
      selectallorder({ storeId: this.selectStoreList?.join(",") }).then(
        (resp) => {
          console.log(resp.data);
          this.dataList = resp.data.map((item) => {
            return {
              ...item,
              storeName:
                this.storeList.find((value) => value.id === item.storeId)
                  ?.storeName || "暂无",
            };
          });
          this.loading = false;
        }
      );
    },
    storeChange() {
      this.select();
    },
    selectBtn() {
      console.log(this.phone, this.orderNumber, this.userId);
      // if (this.phone == "" && this.orderNumber == "" && this.userId == "") {
      //   this.select();
      //   return;
      // }
      selectorderbyname(
        this.phone,
        this.orderNumber,
        this.userId,
        this.selectStoreList?.join(",")
      ).then((resp) => {
        console.log(resp);
        this.loading = false;
        this.dataList = resp.data;
      });
    },
    detailsBtn(row) {
      console.log("------------11111---------", row);
      this.dialogFormVisible2 = true;
      selectOrderDetail(row.orderNumber)
        .then((res) => {
          console.log(res);
          this.orderDetailArr = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发货弹窗
    fahuoBtn(row) {
      console.log(row);
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    // 确认修改
    updataLogisticsNumberBtn() {
      // if (this.form.logisticsNumber == "") {
      //   this.$message.error("请填写物流单号");
      //   return;
      // }
      updateOrder({
        id: this.form.id,
        logisticsNumber: this.form.logisticsNumber,
        address: this.form.address,
        status: this.form.status,
      }).then((res) => {
        console.log(res);
        this.dialogFormVisible = false;
        this.$message.success("发货成功");
        this.select();
      });
    },
    deleteBtn(row) {
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteOrder(row.id).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "id",
          "订单所属门店",
          "订单号",
          "姓名",
          "手机号",
          "发货方式",
          "收货地址",
          "留言",
          "订单总价",

          "物流单号",
          "订单状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "下单时间",
        ];
        const filterVal = [
          "id",
          "storeName",
          "orderNumber",
          "name",
          "phone",
          "delivery",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "status",
          "createTime",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "订单列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },

    // 导入数据
    importExcel(file) {
      // let file = file.files[0] // 使用传统的input方法需要加上这一步
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlm", "xls"].some((item) => item === types);
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then((tabJson) => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          let dateXlx = tabJson[0].sheet; //导入的数据数组
          console.log("------导入的数据为", this.xlsxJson, dateXlx);
          // 判断每一项的姓名 生日 客户类型是否为空 为空则不导入
          // var result = dateXlx.every((item) => {
          //   console.log(item);
          //   return item.name && item.type;
          // });
          // if (!result) {
          //   this.$message.error("姓名，客户类型不能为空！");
          //   return;
          // }
          // 一项项导入数据
          dateXlx.forEach((item) => {
            console.log("item");
            updateSendState(item.id, item["物流单号"]).then((res) => {
              console.log(res);
              this.select();
            });
          });
        }
      });
    },
    file2Xce(file) {
      // return new Promise(function (resolve, reject) {
      return new Promise(function(resolve) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary",
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName]),
            });
          });
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file) // 传统input方法
      });
    },
  },
};
</script>

<style scoped>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.addressDetail:hover {
  cursor: pointer;
}
</style>
